// extracted by mini-css-extract-plugin
export default {"magic_box":"magicball_magic_box__K4LrS","magicball_icons":"magicball_magicball_icons__-9ZnY"};